export default "__VITE_ASSET__Cl7bfQ4U__"